<p-dialog [resizable]="false" [draggable]="false"
  [(visible)]="visible"
  (onHide)="close()"
  [header]="((editingUserId ? 'Edit User' : 'Create User') | translate) + ' (' + ('Legal Entity' | translate) + ')'"
  [modal]="true"
  [style]="{ width: '900px' }"
  [dismissableMask]="true"
  styleClass="user-creation-dialog">
  <div
    *ngIf="isLoading"
    class="loading-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div [ngStyle]="{ opacity: isLoading ? 0.5 : 1, 'pointer-events': isLoading ? 'none' : 'auto' }">
    <p-tabs
      [(value)]="activeTab"
      styleClass="user-creation-tabs">
      <p-tablist>
        <p-tab
          value="0"
          styleClass="tab-main-info">
          {{ "Basic information" | translate }}
        </p-tab>
        <p-tab
          value="1"
          styleClass="tab-additional-info">
          {{ "Roles" | translate }}
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="user-form">
            <div class="form-columns">
              <div class="form-column-left">
                <div class="form-group">
                  <label class="required">{{ "LOGIN" | translate }}</label>
                  <app-input
                    [(ngModel)]="legalEntityForm.login"
                    (ngModelChange)="touchFormValidation()"
                    placeholder="{{ 'ENTER_LOGIN' | translate }}"
                    [disabled]="editingUserId !== null"
                    [style.cursor]="editingUserId !== null ? 'not-allowed' : 'text'" />
                </div>

                <div class="form-group">
                  <label class="required">{{ "E-mail" | translate }}</label>
                  <app-input
                    [type]="'email'"
                    [(ngModel)]="legalEntityForm.email"
                    (ngModelChange)="touchFormValidation()"
                    placeholder="{{ 'Введите email' | translate }}" />
                </div>

                <div class="form-group">
                  <label [class.required]="!editingUserId">{{ "Введите пароль" | translate }}</label>
                  <div
                    class="password-input form-password-input"
                    style="position: relative">
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="legalEntityForm.password"
                      (ngModelChange)="onPasswordChange($event)"
                      name="password"
                      placeholder="{{ 'Введите пароль' | translate }}"
                      style="padding-right: 40px; width: 100%" />
                    <button
                      pButton
                      type="button"
                      class="p-button-text"
                      (click)="showPassword = !showPassword"
                      style="
                        position: absolute;
                        right: 5px;
                        top: 50%; /* Центрируем глаз по вертикали */
                        transform: translateY(-50%);
                        padding: 0.25rem;
                        height: auto;
                      "
                      title="{{ showPassword ? 'Скрыть пароль' : ('Показать пароль' | translate) }}">
                      <i
                        [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                        style="font-size: 1.2rem"></i>
                    </button>
                  </div>

                  <button
                    pButton
                    type="button"
                    class="p-button-text generate-password-btn"
                    (click)="generatePassword()"
                    title="{{ 'Сгенерировать пароль' | translate }}">
                    <img
                      src="assets/icons/main/light/lock-password-line.svg"
                      alt="" />
                    <span>{{ "Сгенерировать пароль" | translate }}</span>
                  </button>
                  <small
                    *ngFor="let error of passwordErrorMessages()"
                    style="color: #e24c4c; margin-top: 4px; font-size: 0.85rem; display: block">
                    {{ error | translate }}
                  </small>
                </div>

                <div class="form-group">
                  <label [class.required]="!editingUserId">{{ "Повторите пароль" | translate }}</label>
                  <div
                    class="password-input form-password-input"
                    style="position: relative">
                    <input
                      [type]="showConfirmPassword ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="legalEntityForm.confirmPassword"
                      (ngModelChange)="onConfirmPasswordChange($event)"
                      name="confirmPassword"
                      placeholder="{{ 'Повторите пароль' | translate }}"
                      style="padding-right: 40px; width: 100%" />
                    <button
                      pButton
                      type="button"
                      class="p-button-text"
                      (click)="showConfirmPassword = !showConfirmPassword"
                      style="
                        position: absolute;
                        right: 5px;
                        top: 45%;
                        transform: translateY(-50%);
                        padding: 0.25rem;
                        height: auto;
                      "
                      title="{{ showConfirmPassword ? 'Скрыть пароль' : ('Показать пароль' | translate) }}">
                      <i
                        [class]="showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                        style="font-size: 1.2rem"></i>
                    </button>
                  </div>
                  <small
                    *ngIf="showPasswordMismatch()"
                    style="color: #e24c4c; margin-top: 4px; font-size: 0.85rem">
                    {{ "PASSWORDS_DO_NOT_MATCH" | translate }}
                  </small>
                </div>
              </div>

              <div class="form-column-right">
                <div class="form-group">
                  <label class="required">{{ "Наименование краткое" | translate }}</label>
                  <app-input
                    [type]="'text'"
                    [(ngModel)]="legalEntityForm.shortName"
                    (ngModelChange)="touchFormValidation()"
                    [name]="'shortName'"
                    placeholder="{{ 'Введите краткое наименование' | translate }}" />
                </div>

                <div class="form-group">
                  <label class="required">{{ "Наименование полное" | translate }}</label>
                  <app-input
                    [type]="'text'"
                    [(ngModel)]="legalEntityForm.fullName"
                    (ngModelChange)="touchFormValidation()"
                    [name]="'fullName'"
                    placeholder="{{ 'Введите полное наименование' | translate }}" />
                </div>

                <div class="form-group inn-form-group">
                  <label class="required">{{ "ИНН" | translate }}</label>
                  <app-input
                    [type]="'text'"
                    [(ngModel)]="legalEntityForm.inn"
                    (ngModelChange)="touchFormValidation()"
                    [name]="'inn'"
                    placeholder="{{ 'ИНН' | translate }}" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ "Комментарий" | translate }}</label>
              <app-input
                [(ngModel)]="legalEntityForm.comment"
                placeholder="{{ 'Введите комментарий' | translate }}" />
            </div>

            <div class="form-group">
              <label>{{ "Основание подключения" | translate }}</label>
              <app-input
                [(ngModel)]="legalEntityForm.connectionBasis"
                placeholder="{{ 'Введите основание подключения' | translate }}" />
            </div>

            <div class="form-group user-select-with-action">
              <label>{{ "Руководитель" | translate }}</label>
              <div class="select-with-button">
                <msf-select-paginated
                  [(model)]="legalEntityForm.parentId"
                  [service]="userService"
                  serviceMethod="identityUserGetByQueryPost"
                  [isUser]="true"
                  optionValue="id"
                  translateBy="none"
                  searchBy="userName"
                  [placeholder]="'Выберите руководителя'"
                  [style.width]="legalEntityForm.parentId ? 'calc(100% - 45px)' : '100%'" />
                <button
                  *ngIf="legalEntityForm.parentId"
                  class="user-action-button"
                  title="Открыть профиль пользователя">
                  <i class="pi pi-user"></i>
                </button>
              </div>
            </div>

            <div class="form-group user-select-with-action">
              <label>{{ "Заместитель" | translate }}</label>
              <div class="select-with-button">
                <msf-select-paginated
                  [(model)]="legalEntityForm.deputyId"
                  [service]="userService"
                  serviceMethod="identityUserGetByQueryPost"
                  [isUser]="true"
                  optionValue="id"
                  translateBy="none"
                  searchBy="userName"
                  [placeholder]="'Выберите заместителя'"
                  [style.width]="legalEntityForm.deputyId ? 'calc(100% - 45px)' : '100%'" />
                <button
                  *ngIf="legalEntityForm.deputyId"
                  class="user-action-button"
                  title="Открыть профиль пользователя">
                  <i class="pi pi-user"></i>
                </button>
              </div>
            </div>

            <div class="form-options">
              <div class="option-item">
                <app-checkbox
                  [(ngModel)]="legalEntityForm.emailConfirmed"
                  class="approved-checkbox"></app-checkbox>
                <label>{{ "Email подтвержден" | translate }}</label>
              </div>
              <div class="option-item">
                <app-checkbox
                  [(ngModel)]="legalEntityForm.approved"
                  class="approved-checkbox"></app-checkbox>
                <label>{{ "Одобрен" | translate }}</label>
              </div>
              <div class="option-item">
                <app-checkbox
                  [(ngModel)]="legalEntityForm.isBlocked"
                  class="approved-checkbox"></app-checkbox>
                <label>{{ "Заблокировать пользователя" | translate }}</label>
              </div>
            </div>

            <div
              *ngIf="legalEntityForm.isBlocked"
              class="blocking-dates">
              <div class="form-group">
                <app-date-picker
                  [(ngModel)]="legalEntityForm.blockoutStartDate"
                  [label]="'BLOCK_START_DATETIME' | translate"
                  [placeholder]="'SELECT_DATE_TIME' | translate"
                  dateFormat="dd.mm.yy"
                  [showTime]="true"
                  [hourFormat]="'24'"
                  [showClear]="true"></app-date-picker>
              </div>

              <div class="form-group">
                <app-date-picker
                  [(ngModel)]="legalEntityForm.blockoutEndDate"
                  [label]="'BLOCK_END_DATETIME' | translate"
                  [placeholder]="'SELECT_DATE_TIME' | translate"
                  dateFormat="dd.mm.yy"
                  [showTime]="true"
                  [hourFormat]="'24'"
                  [showClear]="true"></app-date-picker>
              </div>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="user-form">
            <div class="roles-section">
              <div class="roles-list">
                <div
                  *ngFor="let role of rolesData"
                  class="role-checkbox-item">
                  <app-checkbox [(ngModel)]="legalEntityForm.selectedRoles[role.id]"></app-checkbox>
                  <label
                    [for]="'legal-role-' + role.id"
                    class="role-label">
                    <span class="role-name">{{ role | serverTranslate: "names" }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'Отправить пользователю' | translate"
      class="p-button-text send-button"
      icon="{{ isSend ? 'pi pi-spinner pi-spin' : '' }}"
      (click)="onSendLetter.emit()">
      <img
        src="assets/icons/main/light/lead-icon-send.svg"
        alt=""
        style="width: 16px; height: 16px; margin-right: 8px" />
    </button>
    <button
      pButton
      type="button"
      [label]="'Сохранить' | translate"
      class="save-button"
      icon="{{ isSave ? 'pi pi-spinner pi-spin' : '' }}"
      [disabled]="isSave || !isFormValid()"
      (click)="save()"></button>
  </ng-template>
</p-dialog>
